import { ApiOptions } from '../../api-options.decorator';
import { ParamsAdapter } from '../../params.adapter';

import { ApiBaseCustomer } from './base';

export class ApiCustomer extends ApiBaseCustomer {
  @ApiOptions({ channel: 'account.patch' })
  editAccount(accountId: number, params: ParamsAdapter) {
    return this.patch(`/customer/account/${accountId}`, params);
  }

  @ApiOptions({ channel: 'account.post' })
  createAccount(params: ParamsAdapter) {
    return this.post(`/customer/account`, params);
  }

  @ApiOptions({ channel: 'account.get' })
  getAccount(id: number, params?: ParamsAdapter) {
    return this.get(`/customer/account/${id}`, params);
  }

  @ApiOptions({ channel: 'account.list' })
  getAccounts(params: ParamsAdapter) {
    return this.get('/customer/account', params);
  }

  @ApiOptions({ channel: 'establishment.delete' })
  removeEstablishment(establishmentId: number) {
    return this.delete(`/customer/establishment-to-legal-entity/${establishmentId}`);
  }

  @ApiOptions({ channel: 'establishment.patch' })
  editEstablishment(establishmentId: number, params: ParamsAdapter) {
    return this.patch(`/customer/establishment-to-legal-entity/${establishmentId}`, params);
  }

  @ApiOptions({ channel: 'establishment.post' })
  createEstablishment(params: ParamsAdapter) {
    return this.post(`/customer/establishment-to-legal-entity`, params);
  }

  @ApiOptions({ channel: 'establishment.list' })
  getEstablishments(params: ParamsAdapter) {
    return this.get('/customer/establishment-to-legal-entity', params);
  }

  getEstablishmentsFromInsee(params: ParamsAdapter) {
    return this.get('/customer/establishment/insee-search', params);
  }

  @ApiOptions({ channel: 'legalEntity.delete' })
  removeLegalEntity(legalEntityId: number) {
    return this.delete(`/customer/legal-entity-to-account/${legalEntityId}`);
  }

  @ApiOptions({ channel: 'legalEntity.patch' })
  editLegalEntity(legalEntityId: number, params: ParamsAdapter) {
    return this.patch(`/customer/legal-entity-to-account/${legalEntityId}`, params);
  }

  @ApiOptions({ channel: 'legalEntity.post' })
  createLegalEntity(params: ParamsAdapter) {
    return this.post(`/customer/legal-entity-to-account`, params);
  }

  @ApiOptions({ channel: 'legalEntity.list' })
  getLegalEntities(params: ParamsAdapter) {
    return this.get(`/customer/legal-entity-to-account`, params);
  }

  /**
   * Get delivery point information, filtered by deliveryPoint, site, if provided
   */
  @ApiOptions({ channel: 'deliveryPoint.get' })
  getDeliveryPointInformations(params: ParamsAdapter) {
    return this.get('/customer/point-client-info', params);
  }

  @ApiOptions({ channel: 'deliveryPoint.patch' })
  putDeliveryPointInformation(gridOperator: string, meteringPoint: string, params: ParamsAdapter) {
    return this.put(`/customer/point-client-info/${gridOperator}/${meteringPoint}`, params);
  }

  @ApiOptions({ channel: 'site.delete' })
  removeSite(siteId: number) {
    return this.delete(`/customer/site/${siteId}`);
  }

  @ApiOptions({ channel: 'site.patch' })
  editSite(siteId: number, params: ParamsAdapter) {
    return this.patch(`/customer/site/${siteId}`, params);
  }

  @ApiOptions({ channel: 'site.post' })
  createSite(params: ParamsAdapter) {
    return this.post(`/customer/site`, params);
  }

  @ApiOptions({ channel: 'site.get' })
  getSite(id: number, params?: ParamsAdapter) {
    return this.get(`/customer/site/${id}`, params);
  }

  @ApiOptions({ channel: 'customerSupplier' })
  getSuppliers() {
    return this.get(`/customer/supplier`);
  }
}
